import type { VolunteerStatus } from "@mubin/contracts";

export {
  VOLUNTEER_NATIONALITIES as NATIONALITIES,
  volunteerExperienceLabel as experienceLabel,
  volunteerTimeLabel as timeLabel,
} from "@mubin/contracts";

export const volunteerStatusLabel: Record<VolunteerStatus, string> = {
  new: "جديد",
  interview: "مرحلة المقابلة",
  accepted: "مقبول",
  rejected: "معتذر عنه",
};
